import React from 'react';
import { Grid3x3, Waves, Layers, PaintRoller, Trees, Bath, Droplets, Mountain, Sparkles, Home, Palmtree } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const services = [
  {
    icon: Grid3x3,
    title: 'Pose de carrelage du petit au grand format',
    description: 'Installation professionnelle de carrelage avec jointage soigné, tous formats disponibles.',
    image: 'https://images.unsplash.com/photo-1590772089458-01769687b7f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsYXJnZSUyMGZvcm1hdCUyMHRpbGUlMjBmbG9vcmluZyUyMG1vZGVybnxlbnwwfHx8fDE3NjgyMTc5NTh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Sparkles,
    title: 'Pose de carrelage mosaïque',
    description: 'Création de motifs uniques avec mosaïque pour vos espaces intérieurs et extérieurs.',
    image: 'https://images.unsplash.com/photo-1754552296820-22c693cb1f91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDgzfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Layers,
    title: 'Chape',
    description: 'Réalisation de chapes pour préparer vos sols avant la pose de carrelage.',
    image: 'https://images.unsplash.com/photo-1631719598244-1b73ab317d01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDgzfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: PaintRoller,
    title: 'Ragréage',
    description: 'Ragréage de sols pour obtenir une surface parfaitement plane et lisse.',
    image: 'https://images.unsplash.com/photo-1747729495579-b26ab7b9c3a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDgzfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Palmtree,
    title: 'Terrasse',
    description: 'Pose de carrelage pour terrasses extérieures résistant aux intempéries.',
    image: 'https://images.unsplash.com/photo-1719324923613-ff0884b031ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHx0ZXJyYWNlJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDg5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Waves,
    title: 'Terrasse de piscine',
    description: 'Carrelage antidérapant et résistant au chlore pour abords de piscine.',
    image: 'https://images.unsplash.com/photo-1767022062386-36d4af393776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx0ZXJyYWNlJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDg5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Droplets,
    title: 'Pose de carrelage piscine avec joints et popsit',
    description: 'Installation complète de carrelage de piscine avec étanchéité professionnelle.',
    image: 'https://images.unsplash.com/photo-1682888818696-906287d759f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGV8ZW58MHx8fHwxNzY4MjE0NDc3fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Bath,
    title: 'Rénovation de salle de bain',
    description: 'Transformation complète de votre salle de bain avec carrelage moderne et durable.',
    image: 'https://images.unsplash.com/photo-1682888818704-6dc91e9d7532?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGV8ZW58MHx8fHwxNzY4MjE0NDc3fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Droplets,
    title: 'Douche à l\'italienne',
    description: 'Création de douches à l\'italienne modernes avec carrelage antidérapant.',
    image: 'https://images.unsplash.com/photo-1609280069904-ab36feb3f20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGV8ZW58MHx8fHwxNzY4MjE0NDc3fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Home,
    title: 'Pose de carrelage en terre cuite',
    description: 'Installation de carrelage terre cuite authentique pour un style traditionnel.',
    image: 'https://images.unsplash.com/photo-1764259316836-82affe70e0c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHx0ZXJyYWNvdHRhJTIwZmxvb3IlMjB0aWxlJTIwdHJhZGl0aW9uYWx8ZW58MHx8fHwxNzY4MjE3OTYxfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    icon: Mountain,
    title: 'Pose de pierre naturelle avec traitement des sols',
    description: 'Installation de pierre naturelle avec traitement et protection adaptés.',
    image: 'https://images.unsplash.com/photo-1767022062386-36d4af393776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx0ZXJyYWNlJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDg5fDA&ixlib=rb-4.1.0&q=85'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Carreleur à Saint-Julien-sur-Bibost et dans les Monts du Lyonnais. 
            Expertise complète en pose de carrelage, du neuf à la rénovation.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl transition-all duration-300 border-gray-200 overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 bg-white rounded-full p-3 shadow-lg">
                  <service.icon className="w-6 h-6 text-blue-600" />
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA - REMOVED - Site statique */}
        <div className="text-center mt-16">
          <p className="text-gray-600 text-lg">
            Coordonnées disponibles en bas de page
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
